import { useEffect, useRef, useState } from "react";
import { Col, Row, Button, Table } from "reactstrap";
import CustomPagination from "../../../../components/constants/Pagination";
import uploadImage from '../../../../assets/img/file-upload.png';
import { FaFileUpload } from "react-icons/fa";
import { LuUpload } from "react-icons/lu";
import ImageUploader from "../../../../components/constants/imageCropNew";
import { postRequest } from "../../../../hooks/axiosClient";
import { environmentaldatas } from "../../../../constant/defaultValues";
import { IoMdClose } from "react-icons/io";
import { toast } from "react-toastify";
const image_url = environmentaldatas?.image_url

const Finalize = ({
    data, handleCancel, handleBack,
    postMatchedFields,
    setData,
    getList,
    isGroup = false

}) => {
    // useEffect(() => {
    //     if (data) {
 
    //         const transformed = data.map(item => {

    //             // const groupDetails = Array.isArray(item.group_details)
    //             //     ? item.group_details.map(g => g?.name)
    //             //     : [];

    //             // let parsedTags;
    //             // try {
    //             //     parsedTags = item.tags ? JSON.parse(item.tags) : JSON.parse(groupDetails[0].tags ?? []) ;
    //             //     if (!Array.isArray(parsedTags)) parsedTags = [];
    //             // } catch (e) {
    //             //     parsedTags = [];
    //             // }

    //             const groupDetailsForTags = Array.isArray(item.group_details)
    //             ? item.group_details
    //             : [];

    //             const groupDetails = Array.isArray(item.group_details)
    //                 ? item.group_details.map(g => g?.name)
    //                 : [];
 

    //             let parsedTags = [];

    //             try {
    //                 if (item.tags) {
    //                     parsedTags = typeof item.tags === 'string'
    //                     ? JSON.parse(item.tags)
    //                     : item.tags;
    //                 } else if (groupDetailsForTags[0]?.tags) {
    //                     parsedTags = typeof groupDetailsForTags[0].tags === 'string'
    //                     ? JSON.parse(groupDetailsForTags[0].tags)
    //                     : groupDetailsForTags[0].tags;
    //                 }

    //                 if (!Array.isArray(parsedTags)) parsedTags = [];
    //                 } catch (e) {
    //                 parsedTags = [];
    //             }
 

    //            let websites = [];

    //             try {
    //                 const parsed = typeof item?.website === 'string'
    //                     ? JSON.parse(item.website)
    //                     : item?.website;

    //                 if (Array.isArray(parsed)) {
    //                     websites = parsed.map(g => g?.label).filter(Boolean);
    //                 }
    //             } catch (e) {
    //                 console.warn('Invalid website JSON:', item?.website);
    //             }
 

    //             return {
    //                 ...item,
    //                 website : websites,
    //                 tags: parsedTags?.join(","),
    //                 group_details: groupDetails?.join(","),
    //             };
    //         });
 
    //         setModalData(transformed)
    //     }
    // },[data])

    useEffect(() => {
        if (!data) return;

        const transformed = data.map(item => {
            const groupArray = Array.isArray(item.group_details) ? item.group_details : [];

            const groupNames = groupArray.map(g => g?.name).filter(Boolean);

            let parsedTags = [];

            try {
                if (item.tags) {
                    parsedTags = typeof item.tags === 'string'
                    ? JSON.parse(item.tags)
                    : item.tags;
                } else {
                    const firstValidTags = groupArray.find(g => g?.tags)?.tags;
                    if (firstValidTags) {
                    parsedTags = typeof firstValidTags === 'string'
                        ? JSON.parse(firstValidTags)
                        : firstValidTags;
                    }
                }

                if (!Array.isArray(parsedTags)) parsedTags = [];
            } catch {
                parsedTags = [];
            }

            let websites = [];

            try {
                const parsed = typeof item?.website === 'string'
                    ? JSON.parse(item.website)
                    : item?.website;

                if (Array.isArray(parsed)) {
                    websites = parsed
                    .map(g => g?.label || g?.name)
                    .filter(Boolean);
                }
            } catch {
                console.warn('Invalid website JSON:', item?.website);
            }

            return {
                ...item,
                website: websites,
                tags: parsedTags.join(","),  
                group_details: groupNames.join(","),
            };
        });

        setModalData(transformed);
    }, [data]);
 
 
    const [modalData, setModalData] = useState([]);
    const [fileKey, setFileKey] = useState(Date.now());
    const [modal, setModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [blobImage, setBlobImage] = useState(null);
    const [selProdId, setSelProdId] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);

    const imgInputRefs = useRef({});
    const headersKeys = modalData?.length > 0 ? Object.keys(modalData[0]) : [];
    const headers = isGroup ? headersKeys  : headersKeys.filter(item => item !== "group_details"); 

    const onSelectImg = async (e, item) => {
        const file = e?.target?.files[0];
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

        const maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            toast.error('Image size must be 5MB or less. Please choose a smaller file.');
            return;
        }

        if (file && !allowedTypes.includes(file.type)) {
            toast.warning('Sorry! Only JPEG, PNG, and JPG files are allowed for upload.');
            return;
        }
        setFileKey(Date.now());
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelProdId(item.enc_id);
            setPreviewImage(reader.result);
            setModal(true);
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };

    const handleImageCropSubmit = (blob, url, id) => {
        const item = modalData?.find((item) => item?.enc_id === id)
        postImages(blob, 'post', item, id)
    };

    const postImages = async (imagePath, type, item, id) => {
        const formData = new FormData();
        formData.append('id', id);

        if (type === 'post') {
            if (imagePath) {
                formData.append(`image_path[${0}]`, imagePath);
            }
        } else {
            if (imagePath) {
                formData.append(`deleted_images[${0}]`, imagePath);
            }
        }
        try {
            const reqUrl = `product-image`
            const response = await postRequest(reqUrl, formData, true);
            const res = response.response?.data ?? [];
            if (response.type === 1) {
                const image_path = res?.image_path[0]
                const bulkData = modalData?.map((el) =>
                    el.enc_id === id ? { ...el, image_path: image_path ?? null } : el
                )
                setData(bulkData)
                // postMatchedFields(data, 'product')
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleDeleteImage = (item) => {
        postImages(item?.image_path, 'delete', item, item?.enc_id)
    }

    return (
        <>
            <Row className="">
                <Col md={12}>
                    <div className='table-responsive' style={{ maxHeight: '40vh' }}>
                        {/* <Table className="custom-table">
                            <thead>
                                <tr>
                                    {headers.map((header, index) => (
                                        <th key={index} className="theadStyle">
                                            {header.replace(/_/g, ' ')}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {headers.map((header, colIndex) => (
                                            <td key={colIndex}>
                                                {header === 'image_path' ? (
                                                    item[header] === null ? (
                                                        <span className="upload-image" onClick={() => imgInputRefs.current[item.enc_id].click()}>
                                                            <LuUpload />
                                                            <input
                                                                key={fileKey}
                                                                type='file'
                                                                accept=".jpeg, .png, .jpg"
                                                                ref={ref => imgInputRefs.current[item.enc_id] = ref}
                                                                hidden
                                                                onChange={(e) => onSelectImg(e, item)}
                                                            />
                                                        </span>
                                                    ) : (
                                                        <>
                                                            <div className='img-wrpr prduct-bulk' >
                                                                <span className='image-container'>
                                                                    <img src={image_url + item[header]} style={{ borderRadius: '6px', border: '1px solid rgb(204, 204, 204)' }} />
                                                                    <span className='delete-logo-icon' style={{ right: '0px' }}><div onClick={() => handleDeleteImage(item)} className='ml-4 p-1 rounded-circle' style={{ backgroundColor: '#E5E5E5', cursor: 'pointer', }} >
                                                                        <IoMdClose style={{ fontSize: '10px' }} />
                                                                    </div></span>
                                                                </span>
                                                            </div>
                                                        </>

                                                    )
                                                ) : (
                                                    item[header]
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </Table> */}

                        <Table className="custom-table">
                            <thead>
                                <tr>
                                    {headers
                                        .filter(header => header !== 'enc_id')  
                                        .map((header, index) => (
                                            <th key={index} className="theadStyle" style={{textTransform:'capitalize'}}>
                                                {header.replace(/_/g, ' ')}
                                            </th>
                                        ))}
                                </tr>
                            </thead>
                            <tbody>
                                {modalData?.map((item, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {headers
                                            .filter(header => header !== 'enc_id') 
                                            .map((header, colIndex) => (
                                                // <td key={colIndex}>
                                                //     {header === 'image_path' ? (
                                                //         item[header] === null ? (
                                                //             <span className="upload-image" onClick={() => imgInputRefs.current[item.enc_id].click()}>
                                                //                 <LuUpload />
                                                //                 <input
                                                //                     key={fileKey}
                                                //                     type='file'
                                                //                     accept=".jpeg, .png, .jpg"
                                                //                     ref={ref => imgInputRefs.current[item.enc_id] = ref}
                                                //                     hidden
                                                //                     onChange={(e) => onSelectImg(e, item)}
                                                //                 />
                                                //             </span>
                                                //         ) : (
                                                //             <>
                                                //                 <div className='img-wrpr prduct-bulk'>
                                                //                     <span className='image-container'>
                                                //                         <img src={image_url + item[header]} style={{ borderRadius: '6px', border: '1px solid rgb(204, 204, 204)' }} alt="Product" />
                                                //                         <span className='delete-logo-icon' style={{ right: '0px' }}>
                                                //                             <div onClick={() => handleDeleteImage(item)} className='ml-4 p-1 rounded-circle' style={{ backgroundColor: '#E5E5E5', cursor: 'pointer' }}>
                                                //                                 <IoMdClose style={{ fontSize: '10px' }} />
                                                //                             </div>
                                                //                         </span>
                                                //                     </span>
                                                //                 </div>
                                                //             </>
                                                //         )
                                                //     ) : (
                                                //         item[header]
                                                //     )}
                                                // </td>

                                                <td key={colIndex}>
                                                    {header === 'image_path' ? (
                                                        item[header] === null ? (
                                                            <span className="upload-image" onClick={() => imgInputRefs.current[item.enc_id].click()}>
                                                                <LuUpload />
                                                                <input
                                                                    key={fileKey}
                                                                    type='file'
                                                                    accept=".jpeg, .png, .jpg"
                                                                    ref={ref => imgInputRefs.current[item.enc_id] = ref}
                                                                    hidden
                                                                    onChange={(e) => onSelectImg(e, item)}
                                                                />
                                                            </span>
                                                        ) : (
                                                            <div className='img-wrpr prduct-bulk'>
                                                                <span className='image-container'>
                                                                    <img src={image_url + item[header]} style={{ borderRadius: '6px', border: '1px solid rgb(204, 204, 204)' }} alt="Product" />
                                                                    <span className='delete-logo-icon' style={{ right: '0px' }}>
                                                                        <div onClick={() => handleDeleteImage(item)} className='ml-4 p-1 rounded-circle' style={{ backgroundColor: '#E5E5E5', cursor: 'pointer' }}>
                                                                            <IoMdClose style={{ fontSize: '10px' }} />
                                                                        </div>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        )
                                                    ) : Array.isArray(item[header]) ? (
                                                        <ul style={{ marginBottom: 0 }}>
                                                            {item[header].map((v, idx) => (
                                                                <li key={idx} style={{ listStyle: "none" }}>{typeof v === "object" ? JSON.stringify(v) : v}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        item[header]
                                                    )}
                                                </td>
                                            ))}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                    <ImageUploader
                        onSubmit={(blob, url) => {
                            setCroppedImage(url);
                            setBlobImage(blob);
                            setModal(false);
                            handleImageCropSubmit(blob, url, selProdId);
                        }}
                        onCancel={() => {
                            setModal(false);
                        }}
                        sourceImageUrl={previewImage}
                        setSourceImageUrl={setPreviewImage}
                        openCropModal={modal}
                        setOpenCropModal={setModal}
                        imgAspect={4 / 4}
                        diasbleFreeFlow={true}
                        from={'product'}
                    />

                </Col>
            </Row >
            <div className="form-group text-right modal-btn-grp">
                {/* <Button
                    color="secondary"
                    className="btn btnCancel mr-3"
                    onClick={() => {
                        handleCancel()
                        // getList()
                    }}
                >
                    Skip Image Upload
                </Button> */}
                <Button
                    color="primary"
                    type="submit"
                    className="btn btn-primary float-right"
                    onClick={() => {
                        handleCancel()
                        getList()
                    }}
                >
                    Finish
                </Button>
            </div>
        </>
    );
};

export default Finalize;